



























import Vue from 'vue';
import Spinner from '@/components/common/Spinner.vue';
import ProgressBar from '@/components/common/ProgressBar.vue';
import InstructionsPage from './InstructionsPage.vue';
import ConnectingPage from './ConnectingPage.vue';
import ErrorConnectingToWiFi from './ErrorConnectingToWiFi.vue';
import EnterPassword from './EnterPassword.vue';
import SelectAP from './SelectAP.vue';
import CriticalFail from './CriticalFail.vue';

import store, { LightStatus } from '@/store';
import CloseWindowButton from '@/components/common/CloseWindowButton.vue';
import DeviceType from '@/enums/DeviceType';

export default Vue.extend({
  name: 'PairingPage',
  components: {
    Spinner,
    ProgressBar,
    InstructionsPage,
    ConnectingPage,
    ErrorConnectingToWiFi,
    EnterPassword,
    SelectAP,
    CriticalFail,
    CloseWindowButton,
  },
  computed: {
    connectionStep(): number | undefined {
      const status = this.$store.state.pairingStatus;
      switch (status.type) {
        case 'waitingForCredentials':
          if (status.passwordIsWrong) {
            return 5;
          } else {
            return 1;
          }
        case 'encryptingCredentials':
        case 'connectingToTheLight':
          return 1;
        case 'sendingCredentials':
          return 2;
        case 'waitingDeviceToConnectToTheWiFi': {
          if (this.$store.state.lightStatus === LightStatus.WrongPassword) {
            return 4;
          } else if (
            this.$store.state.lightStatus === LightStatus.APNotFound ||
            this.$store.state.lightStatus === LightStatus.ConnectionFailed
          ) {
            return 6;
          } else {
            return 2;
          }
        }
        case 'creatingDeviceInCloud':
          return 3;
        case 'finishingPairing':
          return 3;
        case 'createLightInCloudFail':
        case 'encryptingCredentialsFail':
        case 'lightConnectionToWifiFail':
          return 7;
      }
      return undefined;
    },
    welcomeHeader(): string | undefined {
      switch (this.$store.state.deviceType) {
        case DeviceType.Light:
          return Vue.i18n.translate('Welcome_Header_Light');
        case DeviceType.Plug:
          return Vue.i18n.translate('Welcome_Header_Smart_Plug');
        case DeviceType.WiFiSwitch:
          return Vue.i18n.translate('Welcome_Header_WiFi_Switch');
        default:
          return undefined;
      }
    },
    faqLinkLocation(): string {
      const defaultUrl =
        'https://faq.wizconnected.com/a/wiz/?l=en&s=getting-started&f=can-t-find-wiz-config-xxxx-in-the-wi-fi-settings-during-manual-setup';
      switch (this.$store.state.deviceType) {
        case DeviceType.Light:
          return Vue.i18n.translate('FAQ_Link_Location_Light') || defaultUrl;
        case DeviceType.Plug:
          return Vue.i18n.translate('FAQ_Link_Location_Plug') || defaultUrl;
        case DeviceType.WiFiSwitch:
          return (
            Vue.i18n.translate('FAQ_Link_Location_WiFi_Switch') || defaultUrl
          );
        default:
          return defaultUrl;
      }
    },
  },
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PairingPage.vue